var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.28 21.5913C16.4721 21.5913 20.6811 17.3823 20.6811 12.1902C20.6811 6.99808 16.4721 2.78906 11.28 2.78906C6.08792 2.78906 1.87891 6.99808 1.87891 12.1902C1.87891 17.3823 6.08792 21.5913 11.28 21.5913Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.88022,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1016 9.37061L8.46094 15.0113",
    stroke: "#5C5C5C",
    strokeWidth: 1.88022,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 9.37061L14.1016 15.0113",
    stroke: "#5C5C5C",
    strokeWidth: 1.88022,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.11f63ec2de25be1fc167486d608b7e41.svg";
export { ForwardRef as ReactComponent };